import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ROUTES from 'constants/routes'
import { CONCEPTS_ANIMATIONS } from 'constants/animations'
import ConceptButton from 'components/Landing/Concepts/ConceptButton'
import ConceptAnimation from 'components/Landing/Concepts/ConceptAnimation'
import LandingButton from 'components/Landing/LandingButton'

const CONCEPTS = [
  {
    title: 'landing.concepts.market_competition',
    animation: CONCEPTS_ANIMATIONS.markets
  },
  {
    title: 'landing.concepts.strategic_decision',
    animation: CONCEPTS_ANIMATIONS.blackboard
  },
  {
    title: 'landing.concepts.growth_profitability',
    animation: CONCEPTS_ANIMATIONS.machine
  }
]

function Concepts() {
  const { t } = useTranslation()

  const [selectedAnimation, setSelectedAnimation] = useState(CONCEPTS[0].animation)

  return (
    <div className="concepts">
      <div className="concepts__selection">
        <div className="concepts__title">{t('landing.concepts.title')}</div>
        <div className="concepts__list">
          {CONCEPTS.map((concept) => (
            <ConceptButton
              key={`concept-button-${concept.title}`}
              animation={concept.animation}
              handleOnSelect={setSelectedAnimation}
              selected={selectedAnimation === concept.animation}
              title={concept.title}
            />
          ))}
          <LandingButton
            className="mt-2"
            to={ROUTES.LANDING_GAME_OVERVIEW}
            text={t('landing.concepts.more')}
            variant="desktop"
          />
        </div>
      </div>
      <div className="concept__animation">
        <ConceptAnimation animation={selectedAnimation} />
        <LandingButton
          className="align-self-start mt-2"
          to={ROUTES.LANDING_GAME_OVERVIEW}
          text={t('landing.concepts.more')}
          variant="mobile"
        />
      </div>
    </div>
  )
}

export default Concepts
